import { country } from '@app/models';
import {gql} from 'apollo-angular';

export const countriesResult = 'countries';
export const countriesQuery = gql`
    query Countries {
        countries {
            ...country
        }
    }
    ${country}
`;
